import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'
import {ItemsListSortingOptions} from '../constants/ItemsListSortingOptions'
import type {
    FilteredItemsPageUrlQueryParams,
    ItemFiltersRequestData,
    ItemsListSorting,
} from '../modules/public/ads/AdsModuleTypes'
import type {
    CommunicationMethod,
    CommunicationMethodFilterValue,
} from '../modules/public/ads/components/category_filters/filters/CommunicationMethodFilter'
import {decodeItemsSearchFiltersFromUrlQueryParam} from './decodeItemsSearchFiltersFromUrlQueryParam'
import {normalizeNumberFromUrl} from './normalizeNumberFromUrl'

// Преобразует URL query параметры фильтров в объект фильтров для запроса к API и для формы фильтров.
// Никогда не упадет с ошибкой.
export async function convertItemFiltersFromUrlQueryToFiltersForRequest(
    filters: FilteredItemsPageUrlQueryParams
): Promise<ItemFiltersRequestData> {
    return {
        minPrice: normalizePriceForItemFilters(filters.minPrice),
        maxPrice: normalizePriceForItemFilters(filters.maxPrice),
        communicationMethod: normalizeCommunicationMethodForItemFilters(filters.cm),
        keywords: typeof filters.keywords === 'string' ? filters.keywords : '',
        location: normalizeNumberFromUrl(filters.location),
        exceptLocation: normalizeNumberFromUrl(filters.exceptLocation),
        sellerId: normalizeNumberFromUrl(filters.sellerId),
        sort: normalizeSortingForItemFilters(filters.sort),
        props: await normalizeGzippedFiltersForItemFilters(filters.f),
    }
}

// Нормализация цены (если значение получено из URL query).
export function normalizePriceForItemFilters(price?: string | null): number | null {
    try {
        if (!price || price.trim().length === 0) {
            return null
        }
        const value = parseInt(price.trim())
        if (isNaN(value)) {
            return null
        }
        return value
    } catch (_e) {
        // Игнорируем ошибку и не логируем, чтобы не заспамить консоль.
        return null
    }
}

// Нормализация способа связи (если значение получено из URL query).
export function normalizeCommunicationMethodForItemFilters(
    value?: string | CommunicationMethodFilterValue | null
): CommunicationMethod | null {
    return (typeof value === 'string' && (value === 'phone' || value === 'messages')) ? value : null
}

// Нормализация сортировки (если значение получено из URL query).
export function normalizeSortingForItemFilters(
    value?: string | ItemsListSorting | null
): ItemsListSorting | null {
    try {
        return value !== 'default' && ItemsListSortingOptions.includes(value as ItemsListSorting)
            ? value as ItemsListSorting
            : null
    } catch (_e) {
        // Игнорируем ошибку и не логируем, чтобы не заспамить консоль.
        return null
    }
}

// Безопасно декодирует и нормализует фильтры динамических свойств из URL query.
async function normalizeGzippedFiltersForItemFilters(
    encodedString?: string | null | unknown
): Promise<AnyObject> {
    if (encodedString && typeof encodedString === 'string') {
        // Декодируем base64+gzip строку с фильтрами динамических свойств в объект.
        try {
            return await decodeItemsSearchFiltersFromUrlQueryParam(encodedString) ?? {}
        } catch (_e) {
            // Игнорируем ошибку и не логируем, чтобы не заспамить консоль.
        }
    }
    return {}
}
